/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Center, Container, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import PrintLayout from '../../../components/Print/PrintLayout';
import BreadcrumbComponent from '../../../components/BreadcrumbComponent/BreadcrumbComponent';
import GeneralAnnuallySaleDetail from '../../../components/MarketDevelopment/AnnuallySale/General/page';
import LifeAnnuallySaleDetail from '../../../components/MarketDevelopment/AnnuallySale/Life/page';
import MicroAnnuallySaleDetail from '../../../components/MarketDevelopment/AnnuallySale/Micro/page';
import composeQueries from '../../../utils/composeQueries';
import c from '../../../constant';
import { getReportTitle } from '../Utils';

function AnnuallySaleReportDetail({ detailReportId = null, detailReportType = null }) {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const id = urlParams.get('id') ?? detailReportId;
	const reportType = urlParams.get('reportType') ?? detailReportType;
	const period = urlParams.get('period') ?? null;
	const reportId = urlParams.get('reportId') ?? null;
	const companyType = urlParams.get('companyType') || null;
	const companyId = urlParams.get('companyId') ?? null;
	const { t } = useTranslation();

	function SpreadSheet() {
		return (
			<>
				{reportType === 'General' && (
					<>
						<GeneralAnnuallySaleDetail id={id} />
					</>
				)}
				{reportType === 'Life' && (
					<>
						<LifeAnnuallySaleDetail id={id} />
					</>
				)}
				{reportType === 'Micro' && (
					<>
						<MicroAnnuallySaleDetail id={id} />
					</>
				)}
			</>
		);
	}

	return (
		<PrintLayout>
			<>
				<Container maxW="container.xl" mt="16px" mb="16px">
					{!(detailReportId && detailReportType) && (
						<BreadcrumbComponent
							list={[
								{
									name: 'Insurance Institute Report',
									path: '/company-submission-report',
								},
								{
									name: period,
									path: '/company-submission-report?period=' + period,
								},
								{
									name: getReportTitle(reportId),
									path: composeQueries('/market-development-data?period=' + period + '&reportId=' + reportId, { companyType, companyId }),
								},
								{
									name: 'Detail',
									path: '#',
								},
							]}
						/>
					)}
					<Center mt="5">
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb={4}
						>
							<Flex
								className="hidden-print responsive-header-for-table"
								bg="#FAFAFA"
								p="16px"
								pt="8px"
								pb="8px"
								mb="16px"
								alignItems="center"
								justifyContent="space-between"
								borderBottom="1px solid #dbdbdb"
							>
								<Text fontSize="x-large" fontWeight="bold">
									{t('Sale Report for Insurance Company')}
								</Text>
							</Flex>
							<SpreadSheet />
						</Box>
					</Center>
				</Container>
			</>
		</PrintLayout>
	);
}

export default AnnuallySaleReportDetail;
